import { useProjectContext } from '../contexts/ProjectContext';

export function useProject() {
    return useProjectContext();
}
